export default __webpack_public_path__ + "static/ActaAgate-Bold-6e1e81db1717573eeb139d1746ac7c34.woff2";